module.exports = __webpack_public_path__ + "img/sugar.d8cc75c4.svg";